/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import axios from 'axios';
import { history } from '../utils/helpers';

/**
 * Get auth object from local storage
 */

const getAuth = () => {
  const authData = localStorage.getItem('getchkdjwt');

  if (authData) {
    try {
      const parsedData = JSON.parse(authData);
      if (parsedData?.token) {
        return parsedData.token;
      } else {
        localStorage.removeItem('getchkdjwt'); // Remove invalid auth data
      }
    } catch (error) {
      console.error("Invalid auth data, clearing storage:", error);
      localStorage.removeItem('getchkdjwt'); // Remove corrupted data
    }
  }

  return null;
};

/**
 * Create axios instance.
 *
 * @type {AxiosInstance}
 */

const auth = getAuth();
const axiosInstance = (() => {
  const params = {};
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  if (auth) {
    Object.assign(headers, { Authorization: `Bearer ${auth}` });
  }

  axios.defaults.headers.common.Authorization = `Bearer ${auth}`;
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    params: params,
    headers: headers
  });
})();

axiosInstance.interceptors.request.use(
  function (config) {
    const token = getAuth();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  data => {
    return Promise.resolve(data);
  },
  error => {

    if (error?.response?.status === 401 && history.location.pathname !== '/login' && history.location.pathname !== '/register') {
      delete axios.defaults.headers.Authorization;
      localStorage.clear()
      window.location.reload(true)
    }
    return Promise.reject(error);
  }
);
const axiosInstanceAdmin = (() => {
  const params = {};
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  
  return axios.create({
    baseURL: process.env.REACT_APP_ADMIN_API_URL,
    params: params,
    headers: headers
  });
})();
 const axiosInstanceRouter = (() => {
  const params = {};
  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json',
   };
 
  return axios.create({
    baseURL: "https://199.17.232.7",
    params: params,
    headers: headers
  });
})();

axiosInstanceRouter.interceptors.request.use(
  function (config) {
    const token = getAuth();
    if (token) config.headers.Authorization = `Bearer  `;
    return config;
  },
  function (error) {

    return Promise.reject(error);
  }
);

export {
  axiosInstance,
  axiosInstanceAdmin,
  axiosInstanceRouter
};
